import React, { useState, useEffect } from "react";

const SecondDescripton = ({ text, maxCharsPerLine = 100 }) => {
  const [lines, setLines] = useState([]);

  useEffect(() => {
    const breakText = () => {
      const screenWidth = window.innerWidth;
      let charsPerLine = maxCharsPerLine;

      // Dynamically set character limits based on screen width
      if (screenWidth >= 1024) charsPerLine = maxCharsPerLine;
      else if (screenWidth >= 640) charsPerLine = 60;
      else if (screenWidth >= 480) charsPerLine = 40;
      else charsPerLine = 35;

      const words = text.split(" ");
      const result = [];

      let currentLine = "";

      for (const word of words) {
        if ((currentLine + " " + word).trim().length <= charsPerLine) {
          currentLine += (currentLine ? " " : "") + word;
        } else {
          if (currentLine) result.push(currentLine);
          currentLine = word;
        }
      }

      if (currentLine) result.push(currentLine);
      setLines(result);
    };

    breakText();
    window.addEventListener("resize", breakText);
    return () => window.removeEventListener("resize", breakText);
  }, [text, maxCharsPerLine]);

  return (
    <p className="text-lg dark:text-jacarta-300 text-center">
      {lines.map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))}
    </p>
  );
};

export default SecondDescripton;
